import type { AiModelVariant } from '@kimuno/api-sdk';
import config from 'config';
import { useSelector } from 'react-redux';

import { selectUser } from '../reducers/user.selectors';
import { useAmplitudeExperiment } from './ampli';

// The backend treats anything except 'sonnet-5' (including an absent field) as
// control. Only the not-yet-answered state leaves requests unannotated; a
// blocked or failed Amplitude fetch resolves to variant 'control' and is sent
// explicitly, letting the server tell "flag said control" from "no flag data".
const useMukiModelVariant = (): AiModelVariant | undefined => {
	const user = useSelector(selectUser);
	const { isReady, variant } = useAmplitudeExperiment(
		user,
		config.amplitudeExperiments.enableMukiSonnet5
	);

	if (!isReady) {
		return undefined;
	}
	return variant === 'on' ? 'sonnet-5' : 'control';
};

export default useMukiModelVariant;
